import React, { useMemo, useState } from "react";
import { Search } from "lucide-react";
import { FAQS } from "../lib/data";
import PageHero from "../components/PageHero";
import CTASection from "../components/CTASection";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";

export default function FAQPage() {
  const [query, setQuery] = useState("");
  const categories = useMemo(() => Array.from(new Set(FAQS.map((f) => f.category))), []);
  const q = query.trim().toLowerCase();

  return (
    <>
      <PageHero eyebrow="FAQ" title="Straight answers, no waffle." subtitle="If you can't find what you're looking for below, ask us directly — we usually reply the same day." />

      <section className="pb-24" data-testid="faq-section">
        <div className="container-page max-w-3xl">
          <div className="relative mb-12">
            <Search className="absolute left-5 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
            <input
              type="search"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Search questions"
              className="w-full rounded-full border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 pl-12 pr-4 py-3.5 text-base focus:border-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-100"
              data-testid="faq-search"
            />
          </div>

          {categories.map((cat) => {
            const items = FAQS.filter((f) => f.category === cat && (!q || f.q.toLowerCase().includes(q) || f.a.toLowerCase().includes(q)));
            if (items.length === 0) return null;
            return (
              <div key={cat} className="mb-10" data-testid={`faq-cat-${cat.toLowerCase().replace(/\s+/g, '-')}`}>
                <h2 className="text-sm font-semibold tracking-[0.18em] uppercase text-blue-600 dark:text-blue-400 mb-4">{cat}</h2>
                <Accordion type="single" collapsible className="space-y-3">
                  {items.map((f, i) => (
                    <AccordionItem key={i} value={`${cat}-${i}`} className="card-surface px-6 border">
                      <AccordionTrigger className="text-left py-5 hover:no-underline font-semibold text-slate-900 dark:text-white">{f.q}</AccordionTrigger>
                      <AccordionContent className="text-slate-600 dark:text-slate-400 pb-5 leading-relaxed">{f.a}</AccordionContent>
                    </AccordionItem>
                  ))}
                </Accordion>
              </div>
            );
          })}
        </div>
      </section>

      <CTASection eyebrow="Still curious?" title="Ask us anything." subtitle="Got a question you haven't found your answer to? Send us an email or use our contact form by clicking 'book a call' below and we'll try get back to you same day, or if not within the day after." />
    </>
  );
}
